@if (data.length > 0) {
  <div>
    @for (column of data; track column) {
      <div class="column">
        <span class="bold">{{column.type}}</span>
        <ul class="columnar-list">
          @for (subtype of column.subtypes; track subtype) {
            <li>
              {{subtype}}
            </li>
          }
        </ul>
      </div>
    }
  </div>
}

@if (data.length === 0) {
  <span>{{ defaultDisplayValue }}</span>
}
